import Button from 'react-bootstrap/Button'
import { useState, useEffect } from "react"
import { NodeAPIService } from "../../../services/apis/NodeAPIService";
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import Warning from "../../../components/Warning";
import AlertMessage from "../../../components/AlertMessage";
import BasicCard from "../../../components/basics/cards/BasicCard";
import './node.css'

const NodeAddEdit = ({ setShowAddEdit, state, setState }) => {

    const [cancelWarning, setCancelWarning] = useState(false);
    const [nodeTypes, setNodeTypes] = useState([]);
    const [consolidationLevels, setConsolidationLevels] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [mappingTypes, setMappingTypes] = useState([]);
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });

    useEffect(() => {
        NodeAPIService.getNodeTypes().then(data => setNodeTypeData(data));
        CommonAPIService.getConsolidationLevels().then(data => setConsolidationLevelsData(data));
        CommonAPIService.getCurrencies().then(data => setCurrenciesData(data));
        CommonAPIService.getMappingTypes().then(data => setMappingTypesData(data));
    }, [])


    const setNodeTypeData = (data) => {
        setNodeTypes(data);

        if (data.length > 0 && state.node.nodeId == "") {
            const node = state.node;
            node.nodeTypeId = data[0].nodeTypeId;
            setState(values => ({ ...values, node: node }))
        }
    }

    const setConsolidationLevelsData = (data) => {
        setConsolidationLevels(data);

        if (data.length > 0 && state.node.nodeId == "") {
            const node = state.node;
            node.consolidationLevelId = data[0].consolidationLevelId;
            setState(values => ({ ...values, node: node }))
        }
    }

    const setCurrenciesData = (data) => {
        setCurrencies(data);
        if (data.length > 0 && state.node.nodeId == "") {
            const node = state.node;
            node.defaultCurrencyId = data[0].currencyId;
            setState(values => ({ ...values, node: node }))
        }
    }

    const setMappingTypesData = (data) => {
        setMappingTypes(data);

        if (data.length > 0 && state.node.nodeId == "") {
            const node = state.node;
            node.mappingTypeId = data[0].mappingTypeId;
            setState(values => ({ ...values, node: node }))
        }
    }

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        const node = state.node;
        node[name] = value;
        setState(values => ({ ...values, node: node }))
    }

    const handleCheck = (e) => {
        const name = e.target.name;
        const value = e.target.checked;
        const node = state.node;
        node[name] = value;
        setState(values => ({ ...values, node: node }))
    }

    // EVENT HANDLERS
    const handleCancel = () => {
        setCancelWarning(true)
    }

    const handleSave = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });
        if (state.node.nodeName === "" || state.node.nodeName === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Node name should not be empty.' })
            return false;
        }

        if (state.node.nodeTypeId === "" || state.node.nodeTypeId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Node type must be supplied.' })
            return false;
        }

        if (state.node.consolidationLevelId === "" || state.node.consolidationLevelId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Consolidation level must be supplied.' })
            return false;
        }

        if (state.node.defaultCurrencyId === "" || state.node.defaultCurrencyId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Default currency must be supplied.' })
            return false;
        }

        if (state.node.mappingTypeId === "" || state.node.mappingTypeId === undefined) {
            setAlertObject({ variant: 'danger', alertMessage: 'Mapping type must be supplied.' })
            return false;
        }

        var node = {
            nodeName: state.node.nodeName,
            nodeTypeId: state.node.nodeTypeId,
            memo: state.node.memo,
            consolidationLevelId: state.node.consolidationLevelId,
            defaultCurrencyId: state.node.defaultCurrencyId,
            mappingTypeId: state.node.mappingTypeId,
            isDeleted: state.node.isDeleted,
        };

        if (state.node.nodeId != "") {
            NodeAPIService.updateNode(state.node.nodeId, node).then(
                data => {
                    const newNodes = state.nodes;
                    const updateIndex = newNodes.findIndex(node => node.nodeId === state.node.nodeId)
                    newNodes[updateIndex] = data;
                    setState(values => ({ ...values, nodes: newNodes }));                    
                    setAlertObject({ variant: 'success', alertMessage: 'Node updated' })
                    setTimeout(() => {
                        setAlertObject({ variant: '', alertMessage: '' });
                    }, 10000);
                }
            );            
        }
        else {
            NodeAPIService.addNode(node).then(
                data => {
                    const newNodes = state.nodes;
                    newNodes.push(data);
                    setState(values => ({ ...values, nodes: newNodes }));                    
                    setAlertObject({ variant: 'success', alertMessage: 'Node added' })
                    setShowAddEdit(false);
                    window.location.reload();
                }
            );            
        }
    }

    return (
        <BasicCard cardConfig={{ cardTitle: 'Node details', cardHeadingElement: 'h4' }}>
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : "" }
            <ul>
                {state.node.nodeId != "" ?
                    <li>
                        <span className='form-row'>
                            <label className='label'>Node code</label>
                            <input type='text' name="nodeCode" value={state.node.nodeCode} disabled onChange={handleChange} className='form-input'></input>
                        </span>
                    </li> : ""
                }
                <li>
                    <span className='form-row'>
                        <label className='label'>Node name</label>
                        <input type='text' name="nodeName" value={state.node.nodeName} onChange={handleChange} className='form-input'></input>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Node type</label>
                        <select name="nodeTypeId" value={state.node.nodeTypeId} onChange={handleChange} className='form-select' >
                            {nodeTypes.map((nodeType) => {
                                return (
                                    <option key={nodeType.nodeTypeId} value={nodeType.nodeTypeId}>
                                        {nodeType.nodeTypeName}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                    </li>
                <li>
                    <span className='form-row'>
                        <label className='label-textarea'>Node memo</label>
                        <textarea name="memo" value={state.node.memo} onChange={handleChange} className='form-text-area' rows='4' cols='50'></textarea>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Parametric category</label>
                        <select name="consolidationLevelId" value={state.node.consolidationLevelId} onChange={handleChange} className='form-select' >
                            {consolidationLevels.map((consolidationLevel) => {
                                return (
                                    <option key={consolidationLevel.consolidationLevelId} value={consolidationLevel.consolidationLevelId}>
                                        {consolidationLevel.consolidationLevelCode}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                    </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Currency</label>
                        <select name="defaultCurrencyId" value={state.node.defaultCurrencyId} onChange={handleChange} className='form-select' >
                            {currencies.map((currency) => {
                                return (
                                    <option key={currency.currencyId} value={currency.currencyId}>
                                        {currency.code}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                    </li>
                <li>
                    <span className='form-row'>
                        <label className='label'>Mapping type</label>
                        <select name="mappingTypeId" value={state.node.mappingTypeId} onChange={handleChange} className='form-select'>
                            {mappingTypes.map((mappingType) => {
                                return (
                                    <option key={mappingType.mappingTypeId} value={mappingType.mappingTypeId}>
                                        {mappingType.mappingTypeName}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                </li>
                <li>
                    <span className='form-row'>
                        <label>Deleted</label>
                        <input type='checkbox' name='isDeleted' onChange={handleCheck} checked={state.node.isDeleted}></input>
                    </span>
                </li>
                {state.node.nodeId != "" ?
                    <li>
                        <span className='form-row'>
                            <label className='label'>Last updated</label>
                            <p className='form-input-right'>{state.node.lastUpdateDate}</p>
                        </span>
                    </li> : ""
                }
                <span className='cancel-save'>
                    <a href='#' onClick={handleCancel}>Cancel</a>
                    <Button variant='primary' onClick={handleSave} className='ml-4'>Save</Button>
                </span>
            </ul>
            <Warning warningText='Are you sure you want to cancel?' handleConfirm={setCancelWarning} handleCancel={setShowAddEdit} show={cancelWarning} />
        </BasicCard>
    )    
}

export default NodeAddEdit